import { useEffect, useRef, useState } from "react";

/**
 * IDs that appeared after the first ready snapshot. Used so Quiet Signals
 * entrance motion does not replay the whole transcript on load.
 */
export function useFreshIds(
  ids: readonly string[],
  ready = true,
): Set<string> {
  const seen = useRef<Set<string> | null>(null);
  const [fresh, setFresh] = useState<Set<string>>(() => new Set());

  useEffect(() => {
    if (!ready) return;
    if (seen.current === null) {
      seen.current = new Set(ids);
      return;
    }
    const next = new Set<string>();
    for (const id of ids) {
      if (!seen.current.has(id)) {
        next.add(id);
        seen.current.add(id);
      }
    }
    if (next.size > 0) setFresh(next);
  }, [ids, ready]);

  return fresh;
}
